<div id="export-import">
    <h2 class="title">Export/Import Savefile</h2>
    <span class="description">
        <p>Here you can export or import your savefile.</p>
        <p>We recommend exporting your savefile from time to time, so that you can rely on your manual backups in the unlikely case that savefile corruption happens.</p>
    </span>
    
    <p>
        <button id="btn-export-savefile">Export Savefile</button>
        <button id="btn-import-savefile">Import Savefile</button>
    </p>
</div>